import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LayoutSelector as OHIFLayoutSelector, ToolbarButton } from '@ohif/ui';

import { ServicesManager } from '@ohif/core';

function LayoutSelector({
  rows,
  columns,
  className,
  servicesManager,
  ...rest
}) {
  const [isOpenTab, setIsOpenTab] = useState(false);

  const {
    hangingProtocolService,
    toolbarService,
  } = (servicesManager as ServicesManager).services;

  useEffect(() => {
    const { unsubscribe } = hangingProtocolService.subscribe(
      hangingProtocolService.EVENTS.PROTOCOL_CHANGED,
      evt => {
        const { protocol } = evt;
      }
    );

    return () => {
      unsubscribe();
    };
  }, [hangingProtocolService]);


  const closeOnOutsideClick = () => {
    window.addEventListener('click', e => {
      setTimeout(() => {
        try {
          let el = { id: '' };
          const elArr = [e.srcElement, e.srcElement.parentElement.parentElement.parentElement];
          for (let index = 0; index < elArr.length; index++) {
            try {
              var obj = elArr[index];
              if (obj.id === 'Layout') {
                obj = obj.parentElement.getElementsByTagName('button')[0];
                if (obj.id === 'icon-Layout')
                  break;
              } else {
                el = obj;
                if (obj.id === 'icon-Layout')
                  break;
              }
            } catch (ex) { };
          }
          if (el.id !== 'icon-Layout') {
            setIsOpenTab(false);
            return;
          }
        } catch (ex) {
          if (isOpenTab)
            setIsOpenTab(false);
        }
      }, 100);
    })

  };

  useEffect(() => {
    if (isOpenTab)
      closeOnOutsideClick();
  }, [isOpenTab]);

  const onInteractionHandler = () => setIsOpenTab(!isOpenTab);
  const DropdownContent = isOpenTab ? OHIFLayoutSelector : null;

  const onSelectionHandler = props => {
    toolbarService.recordInteraction({
      interactionType: 'action',
      commands: [
        {
          commandName: 'setViewportGridLayout',
          commandOptions: { ...props },
          context: 'DEFAULT',
        },
      ],
    });
  };

  return (
    <ToolbarButton
      id="Layout"
      label="Grid Layout"
      icon="tool-layout"
      onInteraction={onInteractionHandler}
      closeOnOutsideClick={closeOnOutsideClick}
      className={className}
      rounded={rest.rounded}
      dropdownContent={
        DropdownContent !== null && (
          <DropdownContent
            rows={rows}
            columns={columns}
            onSelection={onSelectionHandler}
          />
        )
      }
      isActive={isOpenTab}
      type="toggle"
    />
  );
}

LayoutSelector.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  onLayoutChange: PropTypes.func,
  servicesManager: PropTypes.instanceOf(ServicesManager),
};

LayoutSelector.defaultProps = {
  rows: 3,
  columns: 3,
  onLayoutChange: () => { },
};

export default LayoutSelector;
